import { Component, ViewEncapsulation, OnInit, ViewChild, HostListener, DoCheck, ElementRef } from '@angular/core';
import { ShopWindowItem } from "../../../shared/model/shop-window-item";
import { SelfAttendanceService } from "../../../shared/services/self-attendance.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SessionStorageService } from "../../../shared/services/session-storage.service";
import { DtmService } from "../../../services/dtm.service";
import { SYDLEClientID } from "../../../shared/constants/one-constants";
import { Dtm, getDtm } from "../../../shared/enum/dtm";
import { braspagReasonCode, changePackageError, errorMapping } from "../../../shared/constants/errors";
import { environment } from "../../../../environments/environment";
import { DialogLoadingComponent } from "../../../shared/components/dialog-loading/dialog-loading.component";

import { MatDialog } from "@angular/material/dialog";
import { SelfAttendanceData } from "../../../shared/model/self-attendance-data";
import { LoadingService } from 'src/app/shared/services/loading.service';
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
    selector: 'pme-self-attendance-auto-recharge-change',
    templateUrl: './auto-recharge-change.component.html',
    styleUrls: ['./auto-recharge-change.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelfAttendanceAutoRechargeChangeComponent implements OnInit, DoCheck {
  @ViewChild("stickyElement") stickyElement!: ElementRef;
  @ViewChild("divider-bottom-table") dividerElement!: ElementRef;
  // Swiper
  swiperConfig: any = {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    freeMode: true,
    slidesPerView: "auto",
  };


  // Hero Inicial
  heroData: any;
  service: string;
  selfAttendanceData: SelfAttendanceData;

  // Array of Saude do Seu Negocio Plans
  packages: Array<ShopWindowItem> = [null, null, null, null, null, null, null, null];


  // SessionStorage Variables ( REMOVER DEFAULT )
  userId: string;
  businessId: string;
  classificationIdentifier: string;

  selectedPackage: ShopWindowItem;

  redirectUrl: string = environment.serasaHomePage;
  showErrorHero: boolean = false;
  packageIndex: number = 0;
  onMobile: boolean;
  innerWidth: number;
  realIndex: number;
  automaticRecharge: string;
  elementIndex: number = null;
  isProductSelectedMobile: boolean = false;
  stickyPosition: number = 0;
  needSlider: boolean = false;
  sliderIndex: number = 0;
  // Variáveis da nova vitrine
  title: String;
  subTitle: String;
  operation: String;
  sliderPackages: Array<ShopWindowItem> = [];
  packagesLenght: number;
  swiperButtonNext: HTMLElement;
  window: string;
  customValue: number;
  paymentMethodsImages = ["mastercard.png", "visa.png", "elo.png",
    "hipercard.png", "american-express.png",
    "diners-club.png", "discover.png", "boleto.png", "pix.png"]

  constructor(
    public selfAttendanceService: SelfAttendanceService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private sessionStorageService: SessionStorageService,
    public dtmService: DtmService,
    private loading: LoadingService,
    private elementRef: ElementRef,
    public utilsService: UtilsService
  ) {
    // Gambs para funcionar adobe analytics customizado
    this.innerWidth = window.innerWidth;
    this.onMobile = this.innerWidth <= 960;

    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);

    if (!this.sessionStorageService.isReloading()) {
      localStorage.removeItem('selfAttendanceData');
      this.sessionStorageService.resetSessionStorage();
    }

    this.sessionStorageService.clearSessionStorage(
      ['category', 'product', 'identificacaoCompleted', 'pagamentoCompleted', 'sucessoCompleted']
    );

    // Gets the UserID and BusinessId from SessionStorage
    this.getProvisioningParametersFromSessionStorage();
    this.dtmService.pageLoaded(Dtm.AlterarRecarga, true, getDtm(Dtm.AlterarRecarga, this.classificationIdentifier));

    this.route.queryParams.subscribe((params) => {
      if (params.userId && params.businessId) {
        this.userId = params.userId;
        this.businessId = params.businessId;
        this.setProvisioningParametersOnSessionStorage();
      }

      if (params.redirectUrl) {
        this.redirectUrl = params.redirectUrl;
        this.selfAttendanceService.redirectURL = this.redirectUrl;
        sessionStorage.setItem('redirectURL', this.redirectUrl);
      }
    });

    sessionStorage.setItem('selfAttendance', 'true');

    this.window = sessionStorage.getItem("ab_plans_eligibility") === "true" ? "B" : "A";
  }

  openConfirmationDialog(i: number, customValue?: any) {
    this.closeDialogSpinner();

    let automaticRechargeValue = this.packages[i].product.automaticRecharge;
    let automaticRechargeValueFormated = Number.isNaN(Number(automaticRechargeValue)) ? automaticRechargeValue : Number(automaticRechargeValue).toFixed(2).replace('.', ',');

    const valueToFormat = customValue ? customValue : this.packages[i].totalValue;
    const displayValue = this.formatCurrency(valueToFormat);

    let data = {
      size: 'LARGE',
      type: 'info',
      title: 'Confirmar R$ ' + displayValue + ' como sua próxima recarga?',
      contents: [
        '<p> Quando seu crédito for igual ou menor que R$ ' + automaticRechargeValueFormated + ', uma nova recarga de R$ ' + displayValue + ' será realizada automaticamente</p>'
      ],
      buttons: {
        'primary': {
          title: 'Sim',
          action: 'autoRechargeChange',
        },
        'secondary': {
          title: 'Não',
          action: 'close'
        }
      },
      disableCloseButton: true
    }

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.autoRechargeChange) {
        this.navigateAfterConfirmation();
      }
    });
  }

  openBlockedAPIDialog(error) {
    this.closeDialogSpinner();

    let data = {
      size: 'LARGE',
      type: 'info',
      title: 'Você excedeu o número máximo de tentativas',
      contents: [
        '<p>Tente novamente em 24 horas.</p>'
      ],
      buttons: {
        'primary': {
          title: 'OK',
          action: 'redirectHome',
        }
      },
      disableCloseButton: true
    }

    let dialogRef = this.dialog.open(DialogAlertComponent, {
      panelClass: 'pme-dialog-alert-panel',
      autoFocus: false,
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.redirectHome) {
        this.utilsService.returnToLoginPage();
      }
    });
  }
  ngAfterViewInit() {
    if (this.stickyElement) {
      this.stickyPosition = this.stickyElement.nativeElement.offsetTop;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const productsContainer = document.getElementsByClassName('products-container');
    let packagesAvailable = document.getElementsByClassName('product-container-card');
    let packagesDisplayed: Array<Element> = [];
    for (let i = 0; i < packagesAvailable.length; i++) {
      let displayed = packagesAvailable[i].getAttribute('style');
      if (displayed && displayed.match('display:block')) packagesDisplayed.push(packagesAvailable[i]);
    }

    this.needSlider = ((window.innerWidth > 548) &&
      (window.innerWidth < productsContainer[0].clientWidth || packagesAvailable.length > packagesDisplayed.length) &&
      (packagesDisplayed.length > 0));

    if (this.needSlider) {
      this.sliderAction('left');
    } else {
      this.sliderAction('');
    }

    // Gambs para funcionar adobe analytics customizado
    this.innerWidth = event.target.innerWidth;
    this.onMobile = this.innerWidth <= 960;
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }
  getIndex(item: ShopWindowItem) {
    return this.packages.map(item => item.product._id).indexOf(item.product._id);
  }
  componentClick(e: MouseEvent, elementIndex: number) {
    if (e.type == 'click') {
      if ((this.elementIndex === elementIndex) || (!this.isProductSelectedMobile && (this.elementIndex !== elementIndex))) this.isProductSelectedMobile = !this.isProductSelectedMobile;
      this.elementIndex = elementIndex;
    }
  }
  ngOnInit() {

    this.loading.addTask(1);
    this.dtmService.sendPageLoadEvent();
    this.selfAttendanceService
      .getChangeAutomaticRechargeData(this.businessId, this.userId, this.window)
      .subscribe(
        (selfAttendanceData) => {

          this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
          if (selfAttendanceData.service === 'DEACTIVATE_AUTO_RECHARGE') {
            this.router.navigate(['../desativar-recarga-garantida'], { queryParamsHandling: 'preserve', relativeTo: this.route });
          }
          this.service = selfAttendanceData.service;

          if (selfAttendanceData.packages) {
            sessionStorage.setItem('name', selfAttendanceData.account.name);
            sessionStorage.setItem('email', selfAttendanceData.account.email);

            this.packages = selfAttendanceData.packages;
            this.getMaxFeatureListIndex();
            this.sliderPackages = [...this.packages];

            this.packagesLenght = this.packages.length;

            const indexPreferred = this.packages.map(el => el.preferred && !el.disable).indexOf(true);
            if (indexPreferred !== -1) {
              this.sliderPackages.splice(indexPreferred, 1);
              this.sliderPackages.unshift(this.packages[indexPreferred]);
            }
            if (indexPreferred >= 0) {
              this.handlePackageClick(indexPreferred);
            } else {
              let automaticRechargeValue = this.packages[0].product.automaticRecharge;
              this.automaticRecharge = Number.isNaN(automaticRechargeValue) ? String(automaticRechargeValue) : Number(automaticRechargeValue).toFixed(2).replace('.', ',');
            }
            this.loading.finishTask();
          }

          this.setTitlesByService(selfAttendanceData.service, 0);
        },
        (error) => {
          this.showCustomError('changePackageError', error);
        },
        () => {
          this.handleProductsLoadDtm();
        }
      );
  }

  ngDoCheck() {
    if (!this.swiperButtonNext) {
      this.swiperButtonNext = (<HTMLElement>this.elementRef.nativeElement).querySelector(".swiper-button-next")

      if (this.swiperButtonNext)
        this.swiperButtonNext.classList.add("wiggly")
    }
  }

  handleProductsLoadDtm() {
    if (!this.onMobile) {
      this.dtmService.productsLoaded(
        this.packages.map((plan) => (
          { 'classificationName': plan.product.classificationName, 'identifier': plan.product.identifier }))
      );

      this.dtmService.customLoaded(['ProdImpression', 'OverlayImpression']);
      this.dtmService.ruleChange('ProdImpression');
      this.dtmService.sendPageLoadEvent('ProdImpression');
    } else {
      //   if (this.directiveRef) {
      //     this.directiveRef.config.autoplay = {
      //       delay: 0
      //     };

      //     this.directiveRef.startAutoplay();
      //   }
    }
  }


  @HostListener('window:scroll', [])
  onWindowScroll() {

    const productsContainer = document.getElementsByClassName('products-container');
    let packagesAvailable = document.getElementsByClassName('product-container-card');
    let packagesDisplayed: Array<Element> = [];
    for (let i = 0; i < packagesAvailable.length; i++) {
      let displayed = packagesAvailable[i].getAttribute('style');
      if (displayed && displayed.match('display:block')) packagesDisplayed.push(packagesAvailable[i]);
    }

    this.needSlider = ((window.innerWidth > 548) &&
      (window.innerWidth < productsContainer[0].clientWidth || packagesAvailable.length > packagesDisplayed.length) &&
      (packagesDisplayed.length > 0));

    if (packagesDisplayed.length === 0) {
      this.sliderAction('');
    }

    const element = document.querySelectorAll('.sticky-element');
    const windowScroll = window.pageYOffset;
    const windowWidth = window.innerWidth;
    let offSetVitrine = 65;
    if (windowScroll > this.stickyPosition + offSetVitrine && windowWidth > 1280) {

      this.stickyElement.nativeElement.classList.add('fixed');
      element.forEach((element: any) => {
        element.style.position = 'fixed';
      });

    } else {

      this.stickyElement.nativeElement.classList.remove('fixed');


      element.forEach((element: any) => {
        element.style.position = 'relative';
      });
    }
  }


  getValuesBasedOnFeatureList(featureList: any[], product: any) {
    let values = [];
    const mainFeatureList = featureList.map((feature) => feature.name);

    mainFeatureList.forEach((mainFeatureName) => {
      const matchingProductFeature = product.featureList.find(
        (productFeature) => productFeature.name === mainFeatureName
      );

      if (matchingProductFeature) {
        const value = matchingProductFeature.toValue ?? matchingProductFeature.fromValue;
        values.push(value);
      } else {
        values.push(null);
      }
    });
    return values;
  }

  getMaxFeatureListIndex() {
    let maxFeatureListLength = 0;

    this.packages.forEach((pckg) => {
      if (pckg.featureList.length > maxFeatureListLength) {
        maxFeatureListLength = pckg.featureList.length;
        this.packageIndex = this.packages.indexOf(pckg);

      }
    });
  }


  setTitlesByService(service: string, i: number) {
    switch (service) {
      case 'CHANGE_AUTO_RECHARGE':
        let automaticRechargeValue = this.packages[i].product.automaticRecharge;
        let automaticRechargeValueFormated = Number.isNaN(Number(automaticRechargeValue)) ? automaticRechargeValue : Number(automaticRechargeValue).toFixed(2).replace('.', ',');

        this.title = "Selecione seu novo pacote";
        this.subTitle = "A recarga escolhida será feita somente quando seu crédito for igual ou menor que R$ " + automaticRechargeValueFormated + ".";
        this.operation = "alteração";
        break;
      case 'ACTIVATE_AUTO_RECHARGE':
        this.title = "Ativar recarga garantida";
        this.subTitle = 'Quando seu crédito for igual ou menor que R$ ' + this.automaticRecharge + ', será feita uma nova recarga no valor do pacote escolhido, sem desconto aplicado.';
        this.operation = "ativação";
        break;
    }
  }

  getProvisioningParametersFromSessionStorage() {
    this.userId = this.sessionStorageService.getUserId();
    this.businessId = this.sessionStorageService.getBusinessId();

    this.dtmService.userLoaded({
      'userId': this.userId,
      'businessId': this.businessId,
      'clientId': SYDLEClientID
    });

    if (!this.userId || !this.businessId) {
      this.sessionStorageService.setIsLogged(false);
    } else {
      this.sessionStorageService.setIsLogged(true);
    }
  }

  setProvisioningParametersOnSessionStorage() {
    this.sessionStorageService.setUserIdAndBusinessId(this.userId, this.businessId);
    this.dtmService.userLoaded({
      userId: this.userId,
      businessId: this.businessId,
      clientId: SYDLEClientID,
    });

    if (this.userId && this.businessId) {
      this.sessionStorageService.setIsLogged(true);
    }
  }


  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case 'changePackageError':
        integrationErrorMessage = this.showCustomHeroError(integrationError, 'changePackageError');

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case 'errorRFB':
        integrationErrorMessage = this.showCustomHeroError(integrationError, 'errorRFB');

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      default:
        break;
    }
  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {

      if (type === "errorRFB") {
        this.heroData = {
          'type': 'error',
          'title': 'Ops! Infelizmente não podemos prosseguir com a compra desta solução porque sua empresa se enquadra em alguma das situações abaixo:',
          'contents': [
            `<p>- Empresa Inativa na receita federal</p>`,
            `<p>- Ramos de atividades não comercializáveis</p>`,
            `<p>- Empresa com apontamentos de inconsistência na Serasa Experian</p>`,
            `<p>Ainda tem dúvidas? Acesse a nossa <a href="https://serasaempreendedor.zendesk.com/hc/pt-br/requests/new">área de atendimento.</a></p>`
          ]
        }
      } else {
        if (typeof error === "string") {
          error = JSON.parse(error);
        }

        if (error.status && error.error) {
          resultError.status = error.status;
          resultError.endpoint = error.url;
          resultError.name = error.name;

          resultError.handledError = !!error.error._messages.filter((message) => {
            return message.code !== null;
          });

          resultError.errors = error.error._messages.filter((message) => {
            return message.type === "ERROR";
          });

          resultError.warnings = error.error._messages.filter((message) => {
            return message.type === "WARNING";
          });

          // Nova errorString
          resultError.errorString = (resultError.context || "SYDLE") + ":CODE:" + error.status + ":HTTP:" + (resultError.errorCode || resultError.status) + ":POST/" + resultError.endpoint + ":" + JSON.stringify(resultError.errors.map(({ text }) => text));

          /*resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint}:${JSON.stringify(resultError.errors)}:${JSON.stringify(resultError.warnings)}`;*/

          resultError.userMessage = error.error._messages[0].text;
          resultError.code = error.error._messages[0].code;

          switch (type) {
            case 'changePackageError':
              if (changePackageError[resultError.code]) {
                this.heroData = {
                  'type': 'error',
                  'title': changePackageError[resultError.code].title,
                  'contents': changePackageError[resultError.code].contents
                }
              } else {
                this.heroData = {
                  'type': 'error',
                  'title': 'Serviço indisponível!',
                  'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
                }
              }
              break;
            default:
              this.heroData = {
                'type': 'error',
                'title': 'Serviço indisponível!',
                'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
              }
              break;
          }
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData = {
        'type': 'error',
        'title': 'Serviço indisponível!',
        'contents': ['O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.']
      }
    }

    this.closeDialogSpinner();
    this.heroData.showButton = true;
    this.heroData.buttonName = 'Voltar';
    this.heroData.redirectURL = this.redirectUrl;
    this.showErrorHero = true;
    return resultError;
  }

  formatCurrency(value: number) {

    let valueString = String(value).replace(".", ",");
    let finalValue = valueString.includes(",") ? valueString.substr(0, valueString.indexOf(",")) : valueString;

    if (valueString.includes(',')) {
      finalValue += valueString.substr(valueString.indexOf(",")) + (valueString.substr(valueString.indexOf(",")).length === 2 ? "0" : "");
    }

    return finalValue;
  }

  onSwipe() {
    this.swiperButtonNext.classList.remove("wiggly");
  }

  handlePackageClick(i: number) {
    if (this.selectedPackage) {
      this.selectedPackage.selected = false;
    }

    let automaticRechargeValue = this.packages[i].product.automaticRecharge;
    let newAutomaticRecharge = Number.isInteger(automaticRechargeValue) ? automaticRechargeValue.toString() : automaticRechargeValue.toFixed(2).replace('.', ',').toString();

    if (this.automaticRecharge != newAutomaticRecharge) {
      this.automaticRecharge = newAutomaticRecharge;
      this.setTitlesByService(this.service, i);
    }

    this.selectedPackage = this.packages[i];
    this.selectedPackage.selected = true;

    // Adobe Analytics
    // this.dtmService.customLoaded(["ProdClick", "OverlayProdClick"])
    // this.dtmService.productsLoaded([{ classificationName: this.selectedPackage.product.classificationName, identifier: this.selectedPackage.product.identifier }])
    // this.dtmService.ruleChange('prodClick');
    // this.dtmService.sendPageLoadEvent('prodClick');
  }

  handleSwiperPackageClick(i: number) {
    const index = this.packages.findIndex(p => p.product._id === this.sliderPackages[i].product._id);
    this.handlePackageClick(index);
    return index;
  }

  navigate(event: any, isSwipperClick?: boolean) {
    let index: number;
    //let customValue: number | undefined;

    if (isSwipperClick) {
      index = this.handleSwiperPackageClick(event);
    } else {
      index = event.i;
      this.customValue = event.customValue;
    }

    this.handlePackageClick(index);
    this.openConfirmationDialog(index, this.customValue);
    this.dtmService.customClickEventAutoRechargeChange(
      this.classificationIdentifier,
      this.selectedPackage.product.identifier
    );
  }

  navigateAfterConfirmation() {
    this.loading.addTask(1);
    if (this.service === 'ACTIVATE_AUTO_RECHARGE') {
      let selfAttendanceData = this.selfAttendanceService.getCurrentSelfAttendanceData();
      selfAttendanceData.selectedPackage = this.selectedPackage;
      this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
      this.router.navigate(['../recarga-garantida/pagamento'], { relativeTo: this.route })
    } else if (this.service === 'CHANGE_AUTO_RECHARGE') {
      this.selfAttendanceService.changeAutomaticRecharge(this.userId, this.businessId, this.selectedPackage.product._id, this.customValue).subscribe(
        (selfAttendanceData) => {
          this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
          this.selfAttendanceService.redirectURL = this.redirectUrl;
          if (selfAttendanceData.errorRFB) {
            this.showCustomError('errorRFB');
          } else {
            this.router.navigate(['../sucesso'], { relativeTo: this.route });
          }
        },
        (error) => {
          try {
            if (error.error.generalMessages[0].text.includes("Serviço indisponível.")) {
              this.openBlockedAPIDialog(error);
            } else {
              this.showCustomError('changePackageError', error);
            }
          } catch (err) {
            this.showCustomError('changePackageError', error);
          }
        }
      )
    }
  }

  navigateRecharge(isSwipperClick: boolean) {
    this.navigate(this.packages.indexOf(this.selectedPackage), isSwipperClick);
  }

  sliderAction(side: string) {

    let elements = document.getElementsByClassName('product-container-card');
    let products: Array<Element> = [];
    for (let i = 0; i < elements.length; i++) {
      products.push(elements[i]);
    }

    //Calculando quantos elementos cabem na tela
    let packagesDisplayed: Array<Element> = [];
    for (let i = 0; i < elements.length; i++) {
      let displayed = elements[i].getAttribute('style');
      if (displayed && displayed.match('display:block')) packagesDisplayed.push(elements[i]);
    }
    let maxProductsDisplayed = Math.floor((window.innerWidth * 0.9) / ((packagesDisplayed && packagesDisplayed.length > 0) ? packagesDisplayed[0].clientWidth : elements[0].clientWidth));

    if (Math.ceil(elements.length / 2) <= maxProductsDisplayed) {
      products.forEach(product => product.setAttribute('style', 'display:none'));
      if (side === 'left') {
        products.splice(maxProductsDisplayed);
        this.sliderIndex = 0;
        products.forEach(product => product.setAttribute('style', 'display:block'));
        return;
      } else if (side === 'right') {
        products.splice(0, elements.length - maxProductsDisplayed);
        this.sliderIndex = elements.length;
        products.forEach(product => product.setAttribute('style', 'display:block'));
        return;
      }
      products.forEach(product => product.setAttribute('style', 'display:block'));
      return;
    }

    //Mostrando e escondendo os pacotes de acordo com o slider
    if (side === 'left') {
      products.forEach(product => product.setAttribute('style', 'display:none'));
      if (this.sliderIndex === elements.length) {
        if (maxProductsDisplayed === 3) {
          products = products.splice(3, 3);
        } else {
          products.splice(0, Math.floor(maxProductsDisplayed / 2));
          products.splice(elements.length - Math.floor(maxProductsDisplayed / 2), maxProductsDisplayed);
          if (products.length > maxProductsDisplayed) {
            let stop = products.length - maxProductsDisplayed;
            let head = true;
            for (let i = 0; i < stop; i++) {
              if (head) products.pop();
              else products.splice(0, 1);
            }
          }
        }
        this.sliderIndex = Math.ceil(elements.length / 2);
      } else if (this.sliderIndex === Math.ceil(elements.length / 2)) {
        products.splice(maxProductsDisplayed);
        this.sliderIndex = 0;
      } else {
        products.splice(maxProductsDisplayed);
        this.sliderIndex = 0;
      }
      products.forEach(product => product.setAttribute('style', 'display:block'));
      return;
    }
    else if (side === 'right') {
      products.forEach(product => product.setAttribute('style', 'display:none'));
      if (this.sliderIndex === 0) {
        if (maxProductsDisplayed === 3) {
          products = products.splice(3, 3);
        } else {
          products.splice(0, Math.floor(maxProductsDisplayed / 2));
          products.splice(elements.length - Math.floor(maxProductsDisplayed / 2), maxProductsDisplayed);
          if (products.length > maxProductsDisplayed) {
            let stop = products.length - maxProductsDisplayed;
            let head = true;
            for (let i = 0; i < stop; i++) {
              if (head) products.pop();
              else products.splice(0, 1);
            }
          }
        }
        this.sliderIndex = Math.ceil(elements.length / 2);
      } else if (this.sliderIndex === Math.ceil(elements.length / 2)) {
        products.splice(0, elements.length - maxProductsDisplayed);
        this.sliderIndex = elements.length;
      } else {
        products.splice(0, elements.length - maxProductsDisplayed);
        this.sliderIndex = elements.length;
      }
      products.forEach(product => product.setAttribute('style', 'display:block'));
      return;
    }
    products.forEach(product => product.setAttribute('style', 'display:block'));
  }

}
